<template>
    <div>
        <v-container grid-list-xl pt-0>
            <h3 class="">Thợ sửa chữa</h3>
            <page-tool-bar show_search :loading="loader" :search.sync="search">
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="triggerDialog({}, 'create')" color="green" dark>
                            Thêm Thợ Sửa Chữa
                        </v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card class="elevation-2 rounded-lg">
                        <table-tho-sua-chua :search="search" :reload_table="reload_table" :loader.sync="loader"
                            @triggerDialog="triggerDialog" :type="type"></table-tho-sua-chua>
                    </v-card>
                </v-flex>
            </v-layout>

            <dialog-tao-tho-sua-chua :chosen_repairman="chosen_repairman" :dialog="trigger_dialog"
                @changeDialogState="trigger_dialog = $event"
                @reloadTable="reload_table++" :type="type"></dialog-tao-tho-sua-chua>
        </v-container>
    </div>
</template>

<script>
import DialogTaoThoSuaChua from "./DialogTaoThoSuaChua.vue";
import TableThoSuaChua from "./TableThoSuaChua.vue";

export default {
    props: ['type'],
    name: "tho-sua-chua",
    components: {
        DialogTaoThoSuaChua,
        TableThoSuaChua,
    },
    data() {
        return {
            reload_table: 0,
            loader: false,
            search: "",
            chosen_repairman: {},
            trigger_dialog: false,
        };
    },
    methods: {
        triggerDialog: function (repairman, type) {
            this.chosen_repairman = { ...repairman };

            if (type === 'edit' || type === 'create') {
                this.trigger_dialog = !this.trigger_dialog;
            }
        },
    },
    mounted() {
        this.reload_table++;
    }
};
</script>

<style scoped>
.rounded-md {
    border-radius: 8px;
}
</style>